import { Box } from '@mui/material'
import { SmartDialog } from '../../generic/utilities/SmartDialog'
import Workflow from './Workflow'
import { useEffect, useState } from 'react'
import { useNodesState } from 'reactflow'
import { validateWorkflow } from './utils'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import AlertUI from '../../generic/AlertUI'

/**
 * @param {Object} props
 * @param {string} props.parentWorkflowCode Ajuste PO 2026-07-27: code of the workflow the subworkflow
 * hangs from, shown in the graph section's title (its own code/name already fill the header fields)
 * @param {string} props.parentWorkflowName Its free descriptive name, '' when it has none
 */
const SubworkflowDialog = ({ open, setOpen, initialWorkflowData, frontendConfig, acceptSubworkflow, editMode, onEditModeChange, parentPartReference, allowEdit, parentWorkflowCode = '', parentWorkflowName = '', inheritedTemplateLinks = {} }) => {
  const [workflow, setWorkflow] = useState(null)
  // RN117.2: this window has its own accept button, and an open row inside the editor blocks it just
  // as it blocks the editor's own Save — otherwise accepting here would drop the half-typed row.
  const [saveAllowed, setSaveAllowed] = useState(true)
  const [nodes, setNodes, onNodesChange] = useNodesState([])
  const { t_ } = useSmartTranslation()
  const [alertElement, showAlert] = AlertUI()

  useEffect(() => {
    if (open) {
      setWorkflow(structuredClone(initialWorkflowData))
    }
  }, [initialWorkflowData, open])

  return (
    <SmartDialog
      setOpen={open}
      minWidth='calc(100vw - 64px)'
      cancelCallback={() => {
        setOpen(false)
        setNodes([])
      }}
      acceptCallback={async () => {
        const validation = validateWorkflow(workflow, nodes, t_, frontendConfig)
        if (!validation.isValid) {
          showAlert({ title: validation.message, severity: 'error' })
          return
        }

        // HU-05 (DL15): accepting a linked unit that was edited asks first "publish or unlink"; Cancel there (`false`) keeps this dialog open with its edits.
        const accepted = await acceptSubworkflow(workflow, nodes)
        if (accepted === false) {
          return
        }
        setOpen(false)
        setNodes([])
      }}
      accept
      disableAccept={!saveAllowed}
      acceptDisabledReason={t_('Finish editing the open row before saving')}
      cancel
      close={false}
      renderComponent={
        <Box>
          {alertElement}
          <Workflow
            frontendConfig={frontendConfig}
            initialWorkflow={workflow}
            setInitialWorkflow={setWorkflow}
            hideButtonsSubWorkflow
            startInEditMode={editMode}
            nodes={nodes}
            setNodes={setNodes}
            onNodesChange={onNodesChange}
            parentPartReference={parentPartReference}
            onEditModeChange={onEditModeChange}
            allowEdit={allowEdit}
            parentWorkflowCode={parentWorkflowCode}
            parentWorkflowName={parentWorkflowName}
            onSaveAllowedChange={setSaveAllowed}
            inheritedTemplateLinks={inheritedTemplateLinks}
          />
        </Box>
      }
    />
  )
}

export default SubworkflowDialog
